export default __webpack_public_path__ + "static/media/onepay.19273fe7.png";